export enum MedicationState {
    New = 'New',
    Ceased = 'Ceased',
    Existing = 'Existing',
    Expired = 'Expired',
    RePrescribed = 'RePrescribed'
}